﻿import * as React from 'react';
import { Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { IOrderListItem } from '../../../../Entities';
import OrderListRow from '../../../../OrderListRow';
import { Translate } from '../../../../../../shared/LanguageService';

type OrderListProps = {
    orders: IOrderListItem[];
    user: any;
    navigateTo: (route: string) => void;
    newOrderId: string;
};

function OrderList({ orders, user, navigateTo, newOrderId }: OrderListProps) {
    return (
        <Table className="order-table" size="small">
            <TableHead>
                <TableRow>
                    <TableCell className="hidden-sm hidden-xs">
                        {Translate('orders/list/header/order-collection-number')}
                    </TableCell>
                    <TableCell className="hidden-sm hidden-xs">
                        {Translate('orders/list/header/order-placed-at')}
                    </TableCell>
                    <TableCell>{Translate('orders/list/header/booked')}</TableCell>
                    <TableCell>{Translate('orders/list/header/photographer')}</TableCell>
                    <TableCell className="hidden-sm hidden-xs">
                        {Translate('orders/list/header/package')}
                    </TableCell>
                    <TableCell>{Translate('orders/list/header/address')}</TableCell>
                    <TableCell className="hidden-sm hidden-xs">
                        {Translate('orders/list/header/status')}
                    </TableCell>
                    <TableCell className="hidden-sm hidden-xs" />
                    <TableCell />
                </TableRow>
            </TableHead>
            <TableBody>
                {orders.map((order: IOrderListItem, index: number) => (
                    <OrderListRow
                        includeAddress={true}
                        order={order}
                        key={index}
                        user={user}
                        navigateTo={navigateTo}
                        isNewOrder={newOrderId === order.id.toString()}
                    />
                ))}
            </TableBody>
        </Table>
    );
}

export default OrderList;